import { twMerge } from '@/lib/classname/twMerge'
import { InnerHtml } from '@/ui/text/inner-html/InnerHtml.client'
import { type PropsWithChildren } from 'react'
import sanitizeHtml from 'sanitize-html'

export type ListItemProps = PropsWithChildren & UiComponentProps

export function ListItem({
  'data-testid': dataTestId,
  className,
  children,
  ...props
}: ListItemProps) {
  return (
    <li
      {...props}
      className={twMerge('group-data-[type=ordered]:ps-1', className)}
      data-testid={dataTestId}
    >
      {typeof children === 'string' ? <InnerHtml html={sanitizeHtml(children)} /> : children}
    </li>
  )
}
